export const styles = {
  layout: {
    backgroundColor: 'var(--fill-cards)',
    display: 'flex',
    minHeight: '100%',
  },
  sidebar: {
    backgroundColor: 'var(--black)',
    color: 'var(--white)',
  },
  section: {
    minWidth: 0,
    width: '100%',
  },
  header: {},
}
